import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { Grid, IconButton, Button, Autocomplete } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Controller } from "react-hook-form";
import { StyledTextFieldBootstrap } from "../doctor-console/StyledComponents";
import { useEffect } from "react";

const CareContextNonAbdmModal = ({ patId, handleClose }) => {
  const [patientList, setPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showDemographic, setShowDemographic] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    getValues,
    setValue,
    watch,
  } = useForm();

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    setError: setError1,
    getValues: getValues1,
    setValue: setValue1,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setError: setError2,
    getValues: getValues2,
    setValue: setValue2,
  } = useForm();

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          // console.log("get_patient_list_with_aabha_info", res);
          setPatientList(res.data?.data);
        });
    }
  }, [authToken]);
  console.log("PatientList", patientList);

  const findPatient = (data) => {
    const foundPatient = patientList.find(
      (patient) => patient.patient_id === data.patient_id
    );
    if (foundPatient) {
      setShowDemographic(true);
      setSelectedPatient(foundPatient);
      setValue1("name", foundPatient.name);
      setValue1("gender", foundPatient.gender);
      setValue1("age", foundPatient.age);
      setValue1("phoneNo", foundPatient.phone_no);
      console.log("Patient found", foundPatient);
    } else {
      console.log("Patient not found");
    }
  };
  const next = () => {
    setShowSubmit(true);
  };

  useEffect(() => {
    if (patId && patientList.length > 0) {
      const foundPatient = patientList.find(
        (patient) => patient.patient_id === patId
      );

      if (foundPatient) {
        console.log("found patient", foundPatient);
        setSelectedPatient(foundPatient);
        setValue("patient_id", foundPatient.patient_id);
      }
    }
  }, [patId, patientList, setValue]);

  const patientId = watch("patient_id");

  const AddCareContext = () => {
    const reqBody = {
      patient_id: getValues("patient_id"),
      visit_details: getValues2("visit_details"),
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_care_context/`,
        JSON.stringify(reqBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.data.status == "Success") {
          toast.success(
            `Visit Purpose "${res.data.ref_num}" has been created successfully`
          );
          handleClose();
        } else {
          toast.error("some error occurred");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };
  console.log("selected patid", selectedPatient);

  return (
    <>
      {!patId && <h1 style={{ textAlign: "center" }}>Create Visit Purpose</h1>}

      <Grid container justifyContent="center">
        <Grid item xs={12} md={12}>
          {/* <div className="contact-panel mb-50"> */}
          {/* {patId && (
              <IconButton
                onClick={handleClose}
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                <CloseIcon />
              </IconButton>
            )} */}
          {/* {patId && (
              <h1 style={{ textAlign: "center" }}>Create Visit Purpose</h1>
            )} */}
          <form
            className="contact-panel__form"
            style={{ padding: "3%" }}
            onSubmit={handleSubmit(findPatient)}
          >
            <Grid container>
              <Grid item xs={12}>
                <div className="form-group">
                  <label htmlFor="patient_id">Select a Patient</label>

                  <Controller
                    name="patient_id"
                    control={control}
                    rules={{ required: "Patient is required." }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={patientList || []} // Ensure patientList is safe
                        getOptionLabel={(option) =>
                          option?.name
                            ? `${option.name} ${option.patient_id}`
                            : ""
                        }
                        value={
                          patientList.find(
                            (patient) => patient.patient_id === patientId
                          ) || null
                        }
                        onChange={(_, value) => {
                          field.onChange(value?.patient_id || "");
                          setSelectedPatient(value);
                        }}
                        disabled={showDemographic}
                        renderInput={(params) => (
                          <StyledTextFieldBootstrap
                            {...params}
                            // label="Select a Patient"
                            variant="outlined"
                          />
                        )}
                      />
                    )}
                  />

                  {errors.patient_id && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.patient_id.message}
                    </p>
                  )}
                </div>
              </Grid>
              <Grid item xs={12}>
                {/* <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    className="btn__secondary btn__rounded mt-10"
                  >
                    View demographics <i className="icon-arrow-right"></i>
                  </Button> */}
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>View demographics</span>{" "}
                  <i className="icon-arrow-right"></i>
                </button>
              </Grid>
            </Grid>
          </form>

          {showDemographic && (
            <form
              className="contact-panel__form"
              style={{ padding: "3%" }}
              onSubmit={handleSubmit1(next)}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <div className="form-group">
                    <label htmlFor="gender">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      name="name"
                      {...register1("name", {
                        required: "Name is required.",
                      })}
                      disabled
                    />
                    {errors1.name && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors1.name.message}
                      </p>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <div className="form-group">
                    <label htmlFor="gender">Gender</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Gender"
                      name="gender"
                      {...register1("gender", {
                        required: "Gender is required.",
                      })}
                      disabled
                    />
                    {errors1.gender && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors1.gender.message}
                      </p>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <div className="form-group">
                    <label htmlFor="gender">Age</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Age"
                      name="age"
                      {...register1("age", {
                        required: "Age is required.",
                        min: {
                          value: 0,
                          message: "Age must be a positive number.",
                        },
                      })}
                      disabled
                    />
                    {errors1.age && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors1.age.message}
                      </p>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <div className="form-group">
                    <label htmlFor="gender">Phone No</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="--"
                      name="phoneNo"
                      {...register1("phoneNo", {
                        required: "Phone number is required.",
                      })}
                      disabled
                    />
                    {errors1.phoneNo && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors1.phoneNo.message}
                      </p>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    Next <i className="icon-arrow-right"></i>
                  </button>
                </Grid>
              </Grid>
            </form>
          )}

          {showSubmit && (
            <form
              className="contact-panel__form"
              style={{ padding: "3%" }}
              onSubmit={handleSubmit2(AddCareContext)}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <div className="form-group">
                    <label htmlFor="visit_details">Enter Visit Details</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Visit Details"
                      name="visit_details"
                      {...register2("visit_details", {
                        required: "Visit Details is required.",
                      })}
                    />
                    {errors2.visit_details && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors2.visit_details.message}
                      </p>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <button
                    type="submit"
                    // variant="contained"
                    // fullWidth
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    Submit <i className="icon-arrow-right"></i>
                  </button>
                </Grid>
              </Grid>
            </form>
          )}
          {/* </div> */}
        </Grid>
      </Grid>
    </>
  );
};

export default CareContextNonAbdmModal;
